import { MantineProvider, Box, Paper, CloseButton, Text, Loader, LoadingOverlay, Code, Button, Tooltip } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SignInButton, UserButton, useUser } from "@clerk/react";
import { useLocalStorage } from "usehooks-ts";
import { Suspense } from "react";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
        }
    }
})


function HeaderAuthButton() {
    const { isSignedIn, user } = useUser();
    if (isSignedIn) {
        return (
            <Tooltip label={user?.primaryEmailAddress?.emailAddress} withArrow position="bottom-end">
                <Box>
                    <UserButton />
                </Box>
            </Tooltip>
        );
    }
    return (
        <Tooltip label="Oralart staff sign in" withArrow position="bottom-end">
            <SignInButton mode="modal">
                <Button variant="subtle" color="gray" size="xs" compact>Staff sign in</Button>
            </SignInButton>
        </Tooltip>
    );
}

// new comment here
function Banner() {
    return null;
    const [showBanner, setShowBanner] = useLocalStorage("holidayBanner", true)
    // if url parameter contains &denture then show banner
    // if (!window.location.search.includes("denture")) {
    //     return null
    // }

    if (!showBanner) {
        return null;
    }
    return (
        <>
            <Box bg={"black"} py={"xs"} sx={{
                color: "white"
            }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <Box sx={{
                        flexGrow: 1
                    }} />
                    <Text px={"md"} >⭐ ️We are closed for the holidays and re-open on Monday 12 January 2026 ⭐️</Text>
                    <Box sx={{
                        flexGrow: 1
                    }} />
                    <CloseButton onClick={() => {
                        setShowBanner(false);
                    }} mr={"xs"} variant="filled" color="dark" aria-label="Close modal" />
                </Box>
            </Box>
        </>
    );
}


export function Base(props: { children: React.ReactNode }) {

    return (
        <QueryClientProvider client={queryClient}>
            <MantineProvider withGlobalStyles withNormalizeCSS>
                <Notifications />
                <Banner />
                <Box maw={700} mx="auto" mt={"md"} mb={"150px"} px={"sm"} >
                    <Suspense fallback={
                        <LoadingOverlay visible={true} overlayBlur={2} />
                    }>
                        <>
                            <Paper shadow="xs" p="md" radius={"md"} style={{ position: "relative" }}>
                                <img src="./oralart-logo.png" style={{ width: "100%", height: "auto" }} width="1600px" height="401px" />
                                <Box style={{ position: "absolute", top: 10, right: 10 }}>
                                    <HeaderAuthButton />
                                </Box>
                            </Paper>
                            {props.children}
                        </>
                    </Suspense>
                </Box>
            </MantineProvider>
        </QueryClientProvider >

    )
}